import { Plus, Trash2 } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export default function CompetencyMatrixBuilder({ matrix, setMatrix, readOnly }) {
  const total = matrix.reduce((sum, c) => sum + (Number(c.weight) || 0), 0);

  const updateRow = (idx, field, value) => {
    const next = matrix.map((c, i) => (i === idx ? { ...c, [field]: field === "weight" ? Number(value) : value } : c));
    setMatrix(next);
  };
  const addRow = () => setMatrix([...matrix, { name: "", weight: 0 }]);
  const removeRow = (idx) => setMatrix(matrix.filter((_, i) => i !== idx));

  return (
    <div data-testid="competency-matrix-builder">
      <div className="space-y-2">
        {matrix.map((c, idx) => (
          <div key={idx} className="flex items-center gap-3">
            <Input
              value={c.name}
              disabled={readOnly}
              placeholder="Competency name"
              onChange={(e) => updateRow(idx, "name", e.target.value)}
              data-testid={`competency-name-input-${idx}`}
              className="flex-1"
            />
            <Input
              type="number"
              min={0}
              max={100}
              value={c.weight}
              disabled={readOnly}
              onChange={(e) => updateRow(idx, "weight", e.target.value)}
              data-testid={`competency-weight-input-${idx}`}
              className="w-24 font-mono"
            />
            <span className="text-sm text-muted-foreground">%</span>
            {!readOnly && (
              <button
                type="button"
                onClick={() => removeRow(idx)}
                data-testid={`competency-remove-btn-${idx}`}
                className="text-destructive hover:opacity-70 transition-opacity"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            )}
          </div>
        ))}
      </div>
      {!readOnly && (
        <Button type="button" variant="outline" size="sm" className="mt-3" onClick={addRow} data-testid="add-competency-btn">
          <Plus className="h-4 w-4" /> Add Competency
        </Button>
      )}
      <div
        data-testid="competency-weight-total"
        className={`mt-3 font-mono text-sm font-semibold ${total === 100 ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400"}`}
      >
        Total Weight: {total}% {total !== 100 && "(must equal 100%)"}
      </div>
    </div>
  );
}
